import fetchWithToken from "views/auth/signIn/axiosInstance";
import PAGE_IDS from "constants/pageIds";

// Backend gates every /reports/* route behind a "Reports" Page row, but the
// dashboard doesn't seed/manage that row separately — it reuses the Main
// Dashboard page_id (confirmed by the backend dev: same id, no dedicated
// Reports page in the seed).
const REPORTS_PAGE_ID = PAGE_IDS.MAIN_DASHBOARD;

const BASE_URL = () => `${process.env.REACT_APP_NEWS_API_URL}/reports`;

function buildQuery(params) {
  const query = new URLSearchParams();
  query.append("page_id", REPORTS_PAGE_ID);
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });
  return query.toString();
}

async function getReport(path, params) {
  const response = await fetchWithToken(`${BASE_URL()}${path}?${buildQuery(params)}`);
  return response?.data;
}

export const getOverview = ({ from, to } = {}) => getReport("/overview", { from, to });

export const getTopNews = ({ from, to, categoryId, locale, limit } = {}) =>
  getReport("/news/top", { from, to, category_id: categoryId, locale, limit });

export const getViewsByCategory = ({ from, to, locale } = {}) =>
  getReport("/news/views-by-category", { from, to, locale });

export const getPublishingTrend = ({ from, to, interval } = {}) =>
  getReport("/news/publishing-trend", { from, to, interval });

export const getBroadcastStats = ({ from, to } = {}) => getReport("/broadcast", { from, to });

export const getBroadcastTrend = ({ from, to, interval } = {}) =>
  getReport("/broadcast/trend", { from, to, interval });

export const getContentOverview = () => getReport("/content-overview", {});
